import { render, staticRenderFns } from "./cModalGenerarFactura.vue?vue&type=template&id=5704d48a&scoped=true"
import script from "./cModalGenerarFactura.vue?vue&type=script&lang=js"
export * from "./cModalGenerarFactura.vue?vue&type=script&lang=js"
import style0 from "./cModalGenerarFactura.vue?vue&type=style&index=0&id=5704d48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704d48a",
  null
  
)

export default component.exports